import { Chip, Grid } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { ICustomer } from 'src/common/interfaces/dtos/ICustomer';
import VerticalCenter from 'src/vertical-center/vertical-center';
import { styles } from './customer-loyalty-search-results-styles';

const CustomerDisplayItem: React.FC<ICustomerDisplayProps> = ({
  customer,
  onSelect,
  selected,
  showPhoneNumberOnCustomerSearch,
  showStatusOnCustomerSearch,
}): JSX.Element => {
  const classes = styles();

  const selectedCustomerItem = `${selected ? `${classes.selectedCustomer}` : ''}`;
  return (
    <Grid
      container
      direction='row'
      key={customer.consumerAccountNumber}
      className={clsx(classes.customerLoyaltySearch, selectedCustomerItem, {
        [classes.inactiveCustomer]: !customer.isActive,
      })}
      onClick={(): void => onSelect(customer)}
      data-testid={'search-customer'}
    >
      <Grid container item className={classes.firstNameItem}>
        <VerticalCenter justifyContent='flex-start'>
          <span data-testid='customer-name'>{customer.firstName}</span>
        </VerticalCenter>
      </Grid>
      <Grid item className={classes.lastNameItem}>
        <VerticalCenter justifyContent='flex-start'>
          <span>{customer.lastName}</span>
        </VerticalCenter>
      </Grid>
      {showStatusOnCustomerSearch && (
        <Grid item className={classes.activeIcon}>
          <VerticalCenter justifyContent='center'>
            <Chip size='small' label='Inactive' className={classes.chip} />
          </VerticalCenter>
        </Grid>
      )}
      {!showPhoneNumberOnCustomerSearch && (
        <Grid item className={classes.mobileItem}>
          <VerticalCenter justifyContent='flex-start'>
            <span>
              {
                customer.identifiers?.find(indetifier => indetifier.fieldName === 'alternateId')
                  ?.fieldValue
              }
            </span>
          </VerticalCenter>
        </Grid>
      )}
      {showPhoneNumberOnCustomerSearch && (
        <Grid item className={classes.mobileItem}>
          <VerticalCenter justifyContent={showStatusOnCustomerSearch ? 'flex-end' : 'flex-start'}>
            <span>{customer.mobile}</span>
          </VerticalCenter>
        </Grid>
      )}
      <Grid item className={classes.homePhoneItem}>
        <VerticalCenter justifyContent={showStatusOnCustomerSearch ? 'flex-end' : 'flex-start'}>
          <span>{customer.phone}</span>
        </VerticalCenter>
      </Grid>
    </Grid>
  );
};

interface ICustomerDisplayProps {
  customer: ICustomer;
  onSelect: (customer: ICustomer) => void;
  selected: boolean;
  key: string;
  showPhoneNumberOnCustomerSearch: boolean;
  showStatusOnCustomerSearch: boolean;
}

export default React.memo(CustomerDisplayItem);
